import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const RezaListSkeleton = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(LocalizeNameSpaceTypes.Global);

	return (
		<>
			{generateArrayFromLength(5).map((i) => (
				<div
					className="flex flex-col gap-2 p-6 mt-0! border-b border-(--border-subtlest)"
					key={i}>
					<GovSkeleton
						width={generateRandomNumber(40, 90) + '%'}
						height="24px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width={generateRandomNumber(80, 100) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width={generateRandomNumber(30, 50) + '%'}
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
			))}
		</>
	);
};
